import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const cryptoApiHeaders = {
  Authorization: "Bearer PpyxghPwpRxDzy_Er9saX4_I4cg60iri",
};

const baseUrl = "https://api.polygon.io";

export const cryptoApi = createApi({
  reducerPath: "cryptoApi",
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getCryptos: builder.query({
      query: (date) => {
        return {
          url: `/v2/aggs/grouped/locale/global/market/crypto/${date}?adjusted=true`,
          headers: cryptoApiHeaders,
        };
      },
    }),
    getSingleCrypto: builder.query({
      query: (cryptoTicker) => {
        return {
          url: `/v2/aggs/ticker/${cryptoTicker}/prev?adjusted=true`,
          headers: cryptoApiHeaders,
        };
      },
    }),
  }),
});

export const { useGetCryptosQuery, useGetSingleCryptoQuery } = cryptoApi;
